import { FormConfig } from '@/entities/assets/hooks/useFormFields';
import { getPersonFullName } from '@/shared/helpers/names';
import { routes } from '@/shared/helpers/router/routes';
import { AssetDto } from '@/shared/lib/sj-orm';
import { DtoId } from '@/shared/lib/sj-orm/models/base.dto';
import { CollectionToSjMap } from '@/shared/lib/sj-orm/types';
import { isEmpty } from '@/shared/utils/misc';
import { numbers } from '@/shared/utils/numbers';

import { CurrencyValue } from './types';

export const resolveCoOwnerName = (
  id: DtoId | undefined,
  collections: Partial<CollectionToSjMap>,
): string => {
  if (!id) return '-';

  const beneficiary = collections.beneficiaries?.findById(id);
  if (beneficiary) return getPersonFullName(beneficiary, 'display');

  const contact = collections.contacts?.findById(id);
  if (contact) return contact.nickname;

  return '-';
};

export type CoOwnerDocumentLink = { href: string; name: string };

export const resolveCoOwnerDocuments = (
  ids: DtoId[] | undefined,
  collections: Partial<CollectionToSjMap>,
): CoOwnerDocumentLink[] =>
  (ids ?? [])
    .map((id) => {
      const personalId = collections.personalIdentifiersDocuments?.findById(id);
      if (personalId) return { href: routes.personalId(id), name: personalId.name };

      const privateDoc = collections.privateDocuments?.findById(id);
      if (privateDoc) return { href: routes.privateDocument(id), name: privateDoc.name };

      return null;
    })
    .filter((link): link is CoOwnerDocumentLink => link !== null);

export const formatAssetValue = (data: CurrencyValue): string => {
  return isEmpty(data, true) ? '' : numbers.formatPrice(data.value ?? 0, data.from);
};

export const resolvePhoneNumber = (
  // TODO: investigate why the phoneNumber field return string
  raw: { Dropdown?: string; Input?: string } | string | undefined,
): string | null => {
  if (!raw) return null;
  if (typeof raw === 'string') return raw || null;

  return [raw.Dropdown, raw.Input].filter(Boolean).join('') || null;
};

export const getSortedItems = (formData: FormConfig, formKeys: Array<keyof AssetDto>) => {
  let orderCount = formKeys.length;

  const formItems = formKeys
    .map((key) => ({
      order: formData[key].order === undefined ? orderCount++ : Number(formData[key].order),
      key,
    }))
    .sort((a, b) => a.order - b.order);

  return formItems.map(({ key }) => key);
};
